module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/Arrows-5edfa12dd03c0e6556cbf1f543ad7dbf.png";